// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"118":"524180bf","806":"6019df47","910":"abf6b353"}[chunkId] + ".js";
};